/**
 * OCHAT: las rutas de Reservas.
 *
 * Van bajo `accounts/:accountId` como el resto del dashboard, porque el guard de
 * upstream resuelve la cuenta desde `to.params.accountId`.
 *
 * `meta.permissions` incluye al agente en lo operativo: tomar y mover reservas es
 * trabajo diario, igual que responder una conversación.
 *
 * CONFIGURACIÓN: ADMINISTRADOR DE LA CUENTA, NO SUPER ADMIN
 * Bandejas, integraciones y automatizaciones sí están reservadas al operador de la
 * plataforma: son infraestructura, y si un cliente las rompe el que atiende el
 * problema somos nosotros. Los cupos y las tarifas son del NEGOCIO del cliente: el
 * dueño de un hotel tiene que poder subir el precio de un fin de semana sin pedirle
 * permiso a nadie.
 *
 * Y va SIN `SUPER_ADMIN_PERMISSION` a propósito, aunque parezca que sumarlo no
 * cuesta nada. Las policies del servidor exigen `@account_user.administrator?`, que
 * mira el ROL de la membresía; `Custom::AccountUser#permissions` devuelve
 * `super + ['super_admin']`, así que un super admin cuya membresía en esta cuenta sea
 * de agente tendría `['agent', 'super_admin']`: vería la pantalla y comería un 403 al
 * guardar. La ruta espeja exactamente lo que el servidor exige.
 */
import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { SUPER_ADMIN_PERMISSION } from '../config/permissions';
import BookingsPageRouteView from './pages/BookingsPageRouteView.vue';
import BookingsListPage from './pages/BookingsListPage.vue';
import BookingsCalendarPage from './pages/BookingsCalendarPage.vue';
import BookingsNewPage from './pages/BookingsNewPage.vue';
import BookingsInventoryPage from './pages/BookingsInventoryPage.vue';

const operational = {
  permissions: ['administrator', 'agent', SUPER_ADMIN_PERMISSION],
  featureFlag: FEATURE_FLAGS.BOOKINGS,
};

const configuration = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.BOOKINGS,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/reservas'),
    component: BookingsPageRouteView,
    children: [
      {
        path: '',
        name: 'bookings_calendar',
        component: BookingsCalendarPage,
        meta: operational,
      },
      {
        path: 'lista',
        name: 'bookings_list',
        component: BookingsListPage,
        meta: operational,
      },
      {
        path: 'nueva',
        name: 'bookings_new',
        component: BookingsNewPage,
        meta: operational,
      },
      {
        path: 'inventario',
        name: 'bookings_inventory',
        component: BookingsInventoryPage,
        meta: configuration,
      },
    ],
  },
];

export default { routes };
